// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading__eBUYe","text":"style__text__2A32u"};